export const getTotalUniqueSizes = ({ variants }) =>
  variants.reduce((uniqueSizes, variant) => {
    uniqueSizes.add(variant.size);
    return uniqueSizes;
  }, new Set()).size;
